import KeyTakeawaysCard from './KeyTakeawaysCard';
export default KeyTakeawaysCard;
